import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAdminAuth } from "../../context/AdminAuthContext";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch {
      toast.error("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f4f7f8] flex items-center justify-center px-5">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-[12px] shadow-[0_12px_40px_rgba(0,0,0,0.08)] p-8">
        <div className="flex flex-col items-center mb-6">
          <span className="w-12 h-12 rounded-full bg-[#eaf6f8] flex items-center justify-center">
            <Lock className="text-[#0f9fbc]" size={22} />
          </span>
          <h1 className="font-serif-display text-[#222] text-2xl font-bold mt-4">Admin Login</h1>
          <p className="font-serif-body text-[#888] text-[13px] mt-1">Life With Abba dashboard</p>
        </div>
        <label className="block font-serif-body text-[13px] text-[#555] mb-1">Email</label>
        <input value={email} onChange={(e) => setEmail(e.target.value)} type="email"
          className="w-full font-serif-body text-[15px] px-4 py-3 rounded-md border border-[#d7e6ea] focus:outline-none focus:ring-2 focus:ring-[#7ecbd6] mb-4" />
        <label className="block font-serif-body text-[13px] text-[#555] mb-1">Password</label>
        <input value={password} onChange={(e) => setPassword(e.target.value)} type="password"
          className="w-full font-serif-body text-[15px] px-4 py-3 rounded-md border border-[#d7e6ea] focus:outline-none focus:ring-2 focus:ring-[#7ecbd6] mb-6" />
        <button type="submit" disabled={loading}
          className="w-full flex items-center justify-center gap-2 bg-[#0f9fbc] hover:bg-[#008da9] disabled:opacity-70 text-white font-serif-body font-bold py-3 rounded-[4px] transition-colors">
          {loading && <Loader2 size={18} className="animate-spin" />} Sign In
        </button>
      </form>
    </div>
  );
}
